import { Component } from '@angular/core';

@Component({
  selector: 'app-list-collapse',
  templateUrl: './list-collapse.component.html',
  styleUrls: ['./list-collapse.component.scss']
})
export class ListCollapseComponent {

}
